import { z } from 'zod'
import { availabilitySchema } from '~/schemas'
import { fetchApi } from './helpers'

export const fetchAvailabilityData = async ({
  productId,
  performanceId,
  date,
  ...query
}: {
  [key: string]: unknown
  productId: string
  performanceId?: string
  date: string
}) => {
  const response: any = await fetchApi(`/products/${productId}/availability`, {
    query: {
      'search[performance_id]': performanceId,
      'search[date]': date,
      ...query,
    },
  })

  const items = z.array(availabilitySchema).parse(
    response.items?.map((item: Record<string, any>) => ({
      name: item.data?.name,
      price: item.data?.price,
      variationId: item.data?.details?.variation?.id || item.data?.external_id,
      ticketCategory: item.data?.details?.ticket_category
        ? {
            id: item.data.details.ticket_category.data?.id,
            price: item.data.details.ticket_category.data?.price,
            minQuantity: item.data.details.ticket_category.data?.quantity_min,
            maxQuantity: item.data.details.ticket_category.data?.quantity_max,
            title: item.data.details.ticket_category.translation?.data?.name,
            description:
              item.data.details.ticket_category.translation?.data?.description,
          }
        : undefined,
      ticketClass: item.data?.details?.ticketClass,
      details: item.data?.details || {},
    })),
  )

  const total = z.number().parse(response.total)

  return { items, total }
}

export type AvailabilityData = Awaited<ReturnType<typeof fetchAvailabilityData>>
